import React from "react";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileChevron from "../ProfileCommon/ProfileChevron";
import FooterContact from "../../../components/Footer/FooterContact";

const Support = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <div className="flex flex-col flex-1 px-[24px] pb-[120px]">
        <Breadcrumb
         className={"mb-6"}
          breadCrumbTiltle={t("profile.support")}
          onClickBack={() =>
            navigate("/profile", {
              state: { direction: -1 },
              replace: false,
            })
          }
        />
        <ProfileChevron
          title={t("support.termsOfUse")}
          onClick={() => navigate("/profile/support/protection/termsOfUse")}
        />
        <ProfileChevron
          title={t("support.dataProtectionPolicy")}
          onClick={() => navigate("/profile/support/protection/policy")}
        />
        <ProfileChevron
          title={t("support.faq")}
          onClick={() => navigate("/profile/support/faq")}
        />
        <ProfileChevron
          title={t("support.contactUs")}
          onClick={() => navigate("/profile/support/contactUS")}
        />
      </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default Support;
